module.exports = __webpack_public_path__ + "fonts/CangErYuYangTiW02-2.2b202acb.ttf";